import "./style.scss";
import { useMemo } from "react";
import { tasksHeaderSelectConst } from "@/src/constants/tasksConsts";
import BtnDefault from "../../BtnDefault/BtnDefault";
import Refresh from "@/src/svg/header/Refresh";
import Archiv from "@/src/svg/header/Archiv";
import AddNew from "@/src/svg/header/AddNew";
import { setActualOfficeTable, setFilterStatus } from "@/src/store/slices/TasksPage/tasksFiltersSlice";
import { useDispatch, useSelector } from "react-redux";
import VerticalLine from "../../VerticalLine/VerticalLine";
import { RootState } from "@/src/store";
import { isOfficeSwitcherLocked } from "@/src/constants/accessControl";

const HeaderTasks = () => {
  const dispatch = useDispatch();
  const actualOfficeTable = useSelector((state: RootState) => state.tasksFilters.actualOfficeTable);
  const hasFullCountryAccess = useSelector((state: RootState) => state.accessControl.hasFullCountryAccess);
  const allowedOffices = useSelector((state: RootState) => state.accessControl.allowedOffices);
  const isOfficeSelectDisabled = isOfficeSwitcherLocked(hasFullCountryAccess, allowedOffices);

  const officeOptions = useMemo(() => {
    if (hasFullCountryAccess) return tasksHeaderSelectConst;
    return allowedOffices
      .map((office) => tasksHeaderSelectConst.find((item) => item.id === office))
      .filter((item): item is (typeof tasksHeaderSelectConst)[number] => Boolean(item));
  }, [allowedOffices, hasFullCountryAccess]);

  const handleOfficeClick = (officeId: string) => {
    if (isOfficeSelectDisabled) return;
    dispatch(setActualOfficeTable(officeId));
    dispatch(setFilterStatus("All"));
  };

  const handleEventRefresh = () => {
    window.location.reload();
  };

  return (
    <div className="header-tasks">
      <div className="header-tasks-offices" role="group" aria-label="Office" aria-disabled={isOfficeSelectDisabled}>
        {officeOptions.map((item: { id: string; title: string }) => (
          <button
            key={item.id}
            type="button"
            disabled={isOfficeSelectDisabled}
            className={`header-tasks-office-pill ${actualOfficeTable === item.id ? "active" : ""} ${isOfficeSelectDisabled ? "disabled" : ""}`}
            onClick={() => handleOfficeClick(item.id)}
          >
            {item.title}
          </button>
        ))}
      </div>
      <div className="header-bottom-buttons">
        <BtnDefault onClick={handleEventRefresh}>
          <p>Refresh</p>
          <Refresh />
        </BtnDefault>
        <BtnDefault>
          <p>Archiv</p>
          <Archiv />
        </BtnDefault>
        <VerticalLine />
        <BtnDefault
          reverse={true}
          onClick={() => {
            const current = localStorage.getItem("tasksPageCreate");
            if (current === "show") {
              localStorage.removeItem("tasksPageCreate");
            } else {
              localStorage.setItem("tasksPageCreate", "show");
            }
            window.dispatchEvent(new Event("tasksPageCreateChanged"));
          }}
        >
          <p>Add new</p>
          <AddNew />
        </BtnDefault>
      </div>
    </div>
  );
};

export default HeaderTasks;
